
















import { Vue, Component, Prop } from 'vue-property-decorator'

@Component
export default class PaidDeselectionWarning extends Vue {
  @Prop(Object) public libraryProp: object
  @Prop(Boolean) public dialogProp: boolean

  private get library() {
    return this.libraryProp
  }

  private get dialog() {
    return this.dialogProp
  }
}
